import { AuthProvider } from 'react-admin';

const apiUrl = process.env.REACT_APP_API_URL || 'https://admin-markets.moliedev.xyz/api';

export const authProvider: AuthProvider = {
  login: async ({ username, password }) => {
    const request = new Request(`${apiUrl}/login`, {
      method: 'POST',
      body: JSON.stringify({ username, password }),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    });

    const response = await fetch(request);
    if (response.status < 200 || response.status >= 300) {
      throw new Error(response.statusText);
    }

    const { accessToken } = await response.json();
    localStorage.setItem('token', accessToken);
    return Promise.resolve();
  },

  logout: () => {
    localStorage.removeItem('token');
    return Promise.resolve();
  },

  checkAuth: () => {
    const token = localStorage.getItem('token');
    return token ? Promise.resolve() : Promise.reject({ redirectTo: '/login' });
  },

  checkError: (error) => {
    const status = error.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem('token');
      return Promise.reject();
    }
    return Promise.resolve();
  },

  getIdentity: () => {
    return Promise.resolve({
      id: 'admin',
      fullName: 'Admin User',
    });
  },

  getPermissions: () => Promise.resolve(''),
};
